module.exports = __webpack_public_path__ + "static/img/monitiornew5.3ca2ff32.webp";